// extracted by mini-css-extract-plugin
var _1 = "ManageHeaderStyles-module__action___Gsrkf";
var _2 = "ManageHeaderStyles-module__action-text___t277U";
var _3 = "ManageHeaderStyles-module__action-text___t277U";
var _4 = "ManageHeaderStyles-module__back___bMKLi";
var _5 = "ManageHeaderStyles-module__balance___LDeWu";
var _6 = "ManageHeaderStyles-module__balances___XIXxR";
var _7 = "ManageHeaderStyles-module__content___ATZFn";
var _8 = "ManageHeaderStyles-module__currency___AbmYz";
var _9 = "ManageHeaderStyles-module__dropdown-holder___fboyy";
var _a = "ManageHeaderStyles-module__dropdown-holder___fboyy";
var _b = "ManageHeaderStyles-module__fadeInLeftShortAnimation___uKdWP";
var _c = "ManageHeaderStyles-module__fadeInLeftShortestAnimation___Ihpop";
var _d = "ManageHeaderStyles-module__fadeInRightShortAnimation___xoJgx";
var _e = "ManageHeaderStyles-module__fadeInUpAnimation___blYEC";
var _f = "ManageHeaderStyles-module__headline___ppKj2";
var _10 = "ManageHeaderStyles-module__sticky___Bu6Pb";
var _11 = "ManageHeaderStyles-module__title___tO7v1";
var _12 = "ManageHeaderStyles-module__top-holder___g6n7t";
var _13 = "ManageHeaderStyles-module__top-holder___g6n7t";
var _14 = "ManageHeaderStyles-module__value___rIV0t";
export { _1 as "action", _2 as "action-text", _3 as "actionText", _4 as "back", _5 as "balance", _6 as "balances", _7 as "content", _8 as "currency", _9 as "dropdown-holder", _a as "dropdownHolder", _b as "fadeInLeftShortAnimation", _c as "fadeInLeftShortestAnimation", _d as "fadeInRightShortAnimation", _e as "fadeInUpAnimation", _f as "headline", _10 as "sticky", _11 as "title", _12 as "top-holder", _13 as "topHolder", _14 as "value" }
